import { client } from '@/services/fetch.js'
import { toast } from '@/services/toast.js'

export async function getQuestion(questionId) {
  try {
    let url = `/config/templates/polls/api/question/${questionId}`
    return  await client.get(url)
  } catch (error) {
    toast.create('Errore durante il recupero dei dati. riprova', 'error')
  }
}

export async function newQuestion(newQuestion) {
  try {
    let url = `/config/templates/polls/api/question/`
    const question = await client.post(url, newQuestion, 'application/json')

    toast.create('Domanda creata con successo', 'success')

    return question;
  } catch (error) {
    toast.create('Errore durante la creazione della domanda, riprova', 'error')
  }
}

export async function editQuestion(question) {
  try {
    let url = `/config/templates/polls/api/question/${question.id}`
    let questionEdited = await client.put(url, question, 'application/json')

    toast.create('Domanda modificata con successo', 'success')

    return questionEdited;
  } catch (error) {
    toast.create('Errore durante la modifica della domanda, riprova', 'error')
  }
}

export async function reorderQuestion(questionGroup) {
  try {
    let data = {
      id: questionGroup.id,
      questions: []
    }

    let position = 1
    questionGroup['questions'].forEach((question) => {
      data['questions'].push({
        id: question['id'],
        position: position
      })
      question['position'] = position++
    })

    if (data['questions'].length <= 0) {
      return
    }

    let url = `/config/templates/polls/api/question-group/${questionGroup.id}/reorder`
    await client.put(url, data, 'application/json')

    toast.create('Ordinamento effettuato', 'success')
  } catch (error) {
    toast.create('Errore in ordinamento domande, riprova', 'error')
  }
}
